import { useState } from "react";
import CustomButton from "../../../Components/Buttons/Custom";
import ModalSimple from "../../../Components/ModalSimple";
import ChallengePriceModal from "./ChallengePriceModal";
import LeverageSettingsModal from "./LeverageSettingsModal";
import { canManageChallengeSettings } from "../../../helper/adminPermissions";

export default function Buttons({ data, onChallengeChange }) {
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [showLeverageModal, setShowLeverageModal] = useState(false);

  return (
    <>
      <div className="w-full flex gap-2.5 items-center justify-end">
        {canManageChallengeSettings() && <CustomButton text="ویرایش تنظیمات اهرم" svg_name="pen" svgClassName="stroke-zi-border-light size-3" className="w-full max-w-48 !rounded-lg bg-zi-gradient-button-blue text-zi-text-dark" textShadow svgShadow onClick={() => setShowLeverageModal(true)} />}
        <CustomButton
          text="ویرایش قیمت و تخفیف"
          svg_name="pen"
          svgClassName="stroke-zi-border-light size-3"
          className="w-full max-w-48 !rounded-lg bg-zi-gradient-button-blue text-zi-text-dark hocus:ring-offset-1 hocus:ring-inset hocus:ring-1 hocus:ring-zi-border-light hocus:ring-offset-zi-blue-light"
          textShadow={true}
          svgShadow={true}
          onClick={() => setShowPriceModal(true)}
        />
      </div>

      {showPriceModal && (
        <ModalSimple showModal={showPriceModal} setShowModal={setShowPriceModal}>
          <ChallengePriceModal
            onClose={() => setShowPriceModal(false)}
            initialPrice={data?.cost}
            initialDiscount={data?.discount}
            initialDiscountPercent={data?.discount_percent}
          />
        </ModalSimple>
      )}
      {showLeverageModal && <ModalSimple showModal={showLeverageModal} setShowModal={setShowLeverageModal}><LeverageSettingsModal challengeId={data?.id} onClose={() => setShowLeverageModal(false)} onSaved={onChallengeChange} /></ModalSimple>}
    </>
  );
}
